import { useEffect, useState } from "react"

export const Busy: React.FC = () => {
    const [ dots, setDots ] = useState('...')

    useEffect(() => {
        setTimeout(() => {
            if (dots.length === 3) {
                setDots('.');
            } else {
                setDots(dots + '.');
            }
        }, 250)
    }, [dots])
    return (
        <>{dots}</>
    )
}